import { useCustomTranslation } from "../../hooks/useCustomTranslation";
import { ReactComponent as DocIcon } from "../../icons/mv-wg-empty-doc-icon.svg";
import { ReactComponent as ImageIcon } from "../../icons/mv-wg-empty-img-icon.svg";
import { ReactComponent as VidIcon } from "../../icons/mv-wg-empty-vid-icon.svg";

export const GalleryRequested = () => {
  const { t } = useCustomTranslation("Notifications");
  return (
    <div className="gallery-notice-container">
      <div className="gallery-notice-container__content">
        <div className="gallery-requested__icon-container">
          <div className="mv-wg-icon-container gallery-requested__img-icon">
            <ImageIcon />
          </div>
          <div className="mv-wg-icon-container gallery-requested__vid-icon">
            <VidIcon />
          </div>
          <div className="mv-wg-icon-container gallery-requested__doc-icon">
            <DocIcon />
          </div>
        </div>
        <p className="gallery-requested__text">{t("GalleryLoading")}</p>
      </div>
    </div>
  );
};
